import React from "react";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, db } from "./firebase";
import { toast } from "react-toastify";
import { setDoc, doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { translateFirebaseError } from "./Utility/firebaseErrorTranslator";

function SignInwithGoogle({ setIsLoggingIn }) {
  const navigate = useNavigate();

  async function googleLogin() {
    setIsLoggingIn(true); // Oznacz, że trwa proces logowania
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      if (user) {
        const userRef = doc(db, "Users", user.uid);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          // Check if `accessGranted` already exists
          if (userData.accessGranted) {
            console.log("accessGranted already exists.");
          }
        } else {
          // If user does not exist, create new document
          await setDoc(userRef, {
            email: user.email,
            firstName: user.displayName,
            photo: user.photoURL,
            lastName: "",
            termsAccepted: false,
          });
        }
        toast.success("Użytkownik zalogowany", {
          position: "top-center",
          autoClose: 1000,
        });
        // Opóźnij przekierowanie o 2 sekundy
        setTimeout(() => {
          setIsLoggingIn(false);
          navigate("/profile", { replace: true });
        }, 1000);
      }
    } catch (error) {
      if (error.code === "auth/cancelled-popup-request") {
        console.warn("Popup request was cancelled.");
      } else {
        console.error("Google login failed:", error.message);
        const translatedError = translateFirebaseError(error.code, 'google-login');
        toast.error(translatedError, {
          position: "bottom-center",
        });
      }
      setIsLoggingIn(false);
    }
  }

  return (
    <div
      style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
      onClick={googleLogin}
    >
      <img src={require("./Assets/google.png")} width={"57%"} alt="Google Login" />
    </div>
  );
}

export default SignInwithGoogle;